import { Icon } from '@/components/ui/Icon'
import { Loader } from '@/components/ui/Loader'
import { useRouteStore } from '@/store/route'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ReportForm } from './ReportForm'
import styles from './ReportForm/ReportForm.module.scss'

export const ReportPage = () => {
  const navigate = useNavigate()
  const { stop } = useParams<{ partOfDay: string; stop: string }>()
  const currentDonation = useRouteStore((state) => state.currentDonation)
  const currentDonationLoading = useRouteStore(
    (state) => state.currentDonationLoading
  )
  const fetchDonation = useRouteStore((state) => state.fetchDonation)

  const stopId = Number(stop)
  const existingReport = currentDonation?.report

  useEffect(() => {
    if (stopId && !currentDonation) {
      fetchDonation(stopId)
    }
  }, [stopId, currentDonation, fetchDonation])

  if (currentDonationLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <header className={styles.header}>
            <button
              type="button"
              className={styles.backButton}
              onClick={() => navigate(-1)}
            >
              <Icon name="chevron-left" size={20} className={styles.backIcon} />
            </button>
            <h1 className={styles.title}>Report</h1>
          </header>
          <Loader />
        </div>
      </div>
    )
  }

  return (
    <ReportForm
      key={currentDonation?.id ?? 'new'}
      existingReport={existingReport}
      stopId={stopId}
    />
  )
}
